import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useAppSelector } from "../../../hooks/redux";
import { useAction } from "../../../hooks/actions";
import { useLazyGetSystemOverallAnalyticsQuery } from "../../../middleware/analyticsApi";
import { ratingConfig } from "./config";
import { PATHS } from "../../../constants";

export const RatingBox = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Добавляем useLocation
  const { setIsErrorRequest } = useAction();
  const { token } = useAppSelector((state) => state.users);
  const { analyticData } = useAppSelector((state) => state.analytics);
  const [getAnalytics, { error: ratingError, isLoading }] = useLazyGetSystemOverallAnalyticsQuery();
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!token && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [token]);

  const intervalFacilRating = () => {
    getAnalytics();
    // Очищаем предыдущий интервал, если он существует
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    // Устанавливаем новый интервал только если есть токен
    if (token) {
      intervalRef.current = setInterval(() => {
        getAnalytics();
      }, 5000);
    }
  };

  useEffect(() => {
    if (!token) return;
    intervalFacilRating();

    // Функция очистки при размонтировании
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [token]); // Добавляем token в зависимости, чтобы интервал перезапускался при его изменении

  const handleClick = (nameForLink) => {
    // Для ссылок на другие страницы
    if (nameForLink === "overdued_jobs_amount") {
      navigate(PATHS.MAGAZINES_EVENTS + `?status=fire_messages_amount`);
      return;
    }
    if (nameForLink === "near_deadline_jobs_amount") {
      navigate(PATHS.MAGAZINES_EVENTS + `?status=false_fire_messages_amount`);
      return;
    }

    let path = PATHS.LIST_OBJECTS;
    let searchParams = new URLSearchParams();

    // Устанавливаем соответствующий параметр фильтрации
    if (nameForLink === "objects") {
      searchParams.set("resetFilters", "true");
    } else if (nameForLink === "no-link-objects") {
      searchParams.set("noLinkObjects", "6");
    } else if (nameForLink === "alert-objects") {
      searchParams.set("noLinkObjects", "7");
    } else if (nameForLink === "maintenance-objects") {
      searchParams.set("noLinkObjects", "4");
    }

    // Если уже на странице объектов, используем replace для обновления URL без новой записи в истории
    if (location.pathname === PATHS.LIST_OBJECTS) {
      // navigate(`${path}?${searchParams.toString()}`, { replace: true });
      navigate(`${path}?${searchParams.toString()}`);
    } else {
      navigate(`${path}?${searchParams.toString()}`);
    }
  };

  const error = ratingError;

  useEffect(() => {
    setIsErrorRequest(error);
  }, [error]);

  return (
    <>
      {!isLoading && (
        <Box className="analytics_panel">
          {ratingConfig(analyticData).map((item, index) => (
            <Box key={index} className="analytics_panel-block" onClick={() => handleClick(item.nameforLink)}>
              <Typography className="analytics_panel-block-name">{item.name}</Typography>

              <Box className="analytics_panel-block-wrapper">
                <Typography className="analytics_panel-block-amount" sx={{ color: item?.color }}>
                  {item.amount || 0}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};
